import { render, staticRenderFns } from "./SpendingTotalPeriod.vue?vue&type=template&id=0cfcef9a&scoped=true&"
import script from "./SpendingTotalPeriod.vue?vue&type=script&lang=js&"
export * from "./SpendingTotalPeriod.vue?vue&type=script&lang=js&"
import style0 from "./SpendingTotalPeriod.vue?vue&type=style&index=0&id=0cfcef9a&scoped=true&lang=css&"
import style1 from "./SpendingTotalPeriod.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfcef9a",
  null
  
)

export default component.exports